import React from 'react';

export default class UnderAge extends React.Component{

    state = {
        };



    render(){
        return(
            <div style={{textAlign:'center'}}>
            <div style={{display: 'inline-block', textAlign:'center',   margin: '0 auto', fontSize: 22, fontWeight: 'bold   '}}>
           Litujeme, ale nezletilým alkohol neprodáváme!
            </div>
            <div>
                <img src="http://www.brevnovskypivovar.cz/images/logo_pivovar_brevnov.png" width="200px" alt="logo"/>
            </div>

        </div>
    )
    }
}